<template>
  <path
    d="M17 20.0002H5C4.45 20.0002 4 19.5502 4 19.0002V7.00018C4 6.45018 3.55 6.00018 3 6.00018C2.45 6.00018 2 6.45018 2 7.00018V20.0002C2 21.1002 2.9 22.0002 4 22.0002H17C17.55 22.0002 18 21.5502 18 21.0002C18 20.4502 17.55 20.0002 17 20.0002ZM20 2.00018H8C6.9 2.00018 6 2.90018 6 4.00018V16.0002C6 17.1002 6.9 18.0002 8 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00018C22 2.90018 21.1 2.00018 20 2.00018ZM20 12.0002L17.5 10.5002L15 12.0002V4.00018H20V12.0002Z"
  />
</template>
